<template>
  <div class="vs-app-alert">
    <div class="alert-content">
      <span
        v-if="error"
        class="visa-icon visa-icon-alert"
      />
      <div
        class="alert-text"
        role="alert"
        aria-live="assertive"
      >
        <p class="vs-text alert-text-element">
          <span v-html="message" />
        </p>
        <p
          v-for="(infoVal, infoKey) in infoMapObj"
          :key="infoKey"
          class="vs-text vs-meta alert-text-element"
        >
          {{ infoKey }}: {{ infoVal }}
        </p>
      </div>
      <button
        class="visa-icon visa-icon-close vs-btn-close"
        :aria-label="allyCloseLabel"
        @click="close"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VsAppAlert',
  props: {
    id: { type: String, default: '' },
    message: { type: String, default: '' },
    error: { type: Boolean, default: true },
    allyCloseLabel: { type: String, default: 'Close Alert' },
    infoMap: { type: String, default: '{}' },
  },
  computed: {
    infoMapObj() {
      return JSON.parse(this.infoMap);
    },
  },
  methods: {
    close() {
      document.dispatchEvent(
        new CustomEvent('click_button_app_alert', { detail: this.id })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import './appAlert';
@import '@/styles/core/types/types';
@import '@/styles/accessibility';
</style>
